import MicroModal from 'micromodal';

export default function popup() {
  const widgetName = 'popup';
  const widgetOpts = popupOpts;
  const $widget = $(`#${widgetName}`);

  // Storage selector-------------
  const sectionTrigger = 'homepage';
  const cookiesTimeStamp = 1;
  const buttonText = 'More';

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createPopup(data.items[0]);
      } else {
        $widget.remove();
      }
    },
    itemsPerPanel: 1,
    link: [],
    maxItemsVisible: 1,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
  });

  function createPopup(d) {
    const title = d.Title;
    const description =
      d.Description == null ? '' : `<p class="modal__description">${d.Description}</p>`;
    const url =
      d.URL == null ? '' : `<a href="${d.URL}" class="button" target="_blank">${buttonText}</a>`;

    function initializePopupModal() {
      $('body').append(`
          <div class="micromodal-slide" id="modal" aria-hidden="true">
            <div class="modal__overlay" tabindex="-1">
              <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-title">
                <button aria-label="Close modal" class="modal-close-btn button" data-micromodal-close>X</button>
                <div class="modal__content" id="modal-content">
                  <div class="modal__content-left">
                    <img class="modal__image" alt="${title}" src="${CLIENTRESOURCEPATH}dist/images/fairgrounds-logo.png" />
                  </div>
                  <div class="modal__content-right">
                    <h2 class="modal__title" id="modal-title">${title}</h2>
                    ${description}
                    ${url}
                  </div>
                </div>
              </div>
            </div>
          `);

      MicroModal.show('modal', { disableScroll: true });
    }

    if (navigator.cookieEnabled && !$('#modal').length && $('body').hasClass(sectionTrigger)) {
      if (Cookies.get('modalCookie')) {
        return false;
      } else {
        Cookies.set('modalCookie', 'modalCookie', { expires: cookiesTimeStamp });
        initializePopupModal();
      }
    }
  }
}
